import { render, staticRenderFns } from "./CartRegistration.vue?vue&type=template&id=464a5766"
import script from "./CartRegistration.vue?vue&type=script&lang=js"
export * from "./CartRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports